import { LoadingButton } from '@mui/lab';
import { Box } from '@mui/material';
import { useNotification } from '@revenuewell/front-end-bundle';
import { FC, useEffect, useState } from 'react';
import { useInsuranceApi } from '../../../../../hooks/use-insurance-api';
import { ProviderSelectionDialog } from '../../../shared/components/provider-selection-dialog/provider-selection-dialog';
import { usePatientIvStatusDialog } from '../../hooks/use-patient-iv-status-dialog/hook';

export interface IButtonProps {
  onSuccess: () => Promise<void>;
  disabled?: boolean;
}

export const SelfPayButton: FC<IButtonProps> = (props) => {
  const { onSuccess, disabled } = props;
  const { showError, showSuccess } = useNotification();
  const { status, selfPayVerification } = useInsuranceApi();
  const {
    locationId,
    providerId,
    patientFlow,
    sendIvStatusUpdatedEvent,
    setIsLoading,
    verificationPriority,
    providers
  } = usePatientIvStatusDialog();
  const [providerDialogOpen, setProviderDialogOpen] = useState(false);

  useEffect(() => {
    if (status.selfPayVerification.error) showError('Unable to perform the operation.');
  }, [status.selfPayVerification.error]);

  const updateInsuranceStatus = async () => {
    if (providerId) await performSelfPayRequest(providerId);
    else setProviderDialogOpen(true);
  };

  const performSelfPayRequest = async (provId: number) => {
    setIsLoading(true);

    const success = await selfPayVerification(locationId, patientFlow.patientId, provId, verificationPriority);

    if (success) {
      showSuccess('Status was updated successfully.');
      sendIvStatusUpdatedEvent();
      await onSuccess();
    }

    setIsLoading(false);
  };

  const handleProviderDialogSubmit = async (selectedProviderId: number) => {
    await performSelfPayRequest(selectedProviderId);
    setProviderDialogOpen(false);
  };

  const handleProviderDialogClose = () => {
    setProviderDialogOpen(false);
  };

  return (
    <Box>
      <LoadingButton
        variant="outlined"
        color="primary"
        disableElevation
        onClick={updateInsuranceStatus}
        disabled={disabled}
        loading={status.selfPayVerification.isRunning}
      >
        Self Pay
      </LoadingButton>
      <ProviderSelectionDialog
        open={providerDialogOpen}
        title="Self Pay - Choose Provider"
        providers={providers}
        onClose={handleProviderDialogClose}
        onSubmit={handleProviderDialogSubmit}
      />
    </Box>
  );
};
